import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

// ── Modo de Stripe: prueba o real ────────────────────────────────────────────
// Solo platform admin. El modo NO es por cuenta: hay una cuenta de Stripe y una
// llave activa, compartida por el cobro de mensualidades y por el cobro a los
// clientes. Ver server/services/stripeMode.ts.

export interface StripeModeStatus {
  mode: 'test' | 'live';
  isTest: boolean;
  /** Sin la llave del modo destino, cambiar dejaría el cobro caído — el
   *  servidor rechaza el cambio y la UI desactiva el botón. */
  hasTestKey: boolean;
  hasLiveKey: boolean;
  /** La llave cargada dice un modo distinto del declarado. */
  mismatch: boolean;
  /** Todavía usando el slot histórico sin sufijo de modo. */
  usingLegacySlot: boolean;
}

export function useStripeMode(enabled = true) {
  return useQuery<StripeModeStatus>({
    queryKey: ['stripe-mode'],
    queryFn: () => api.get<StripeModeStatus>('/api/settings/stripe-mode'),
    enabled,
    staleTime: 60 * 1000,
  });
}

export function useSetStripeMode() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (mode: 'test' | 'live') =>
      api.put<StripeModeStatus>('/api/settings/stripe-mode', { mode }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['stripe-mode'] });
      void qc.invalidateQueries({ queryKey: ['billing-payment-capability'] });
    },
  });
}
